import React, { useState } from 'react'
import { FormInstance } from 'antd'
import { TextAreaRef } from 'antd/es/input/TextArea'
import FormulaAddFunction from '../../formulas/components/FormulaAddFunction'
import FormulaSource from '../../formulas/components/FormulaSource'
import { useTextAreaCursor } from '../../../utils/hooks'
import { useFunctions } from '../../../pages/settings/company/keyFigures/formulas/functions'
import { useAuthorizedData } from '../../../utils/Authorizable/authorize'
import { useCtxDrivers } from '../../formulas/queries/useCtxDrivers'
import FormulaError from '../../formulas/components/FormulaError'
import FormulaSuggestion from '../../formulas/components/FormulaSuggestion'

interface DriverSourceProps {
  form: FormInstance
  requestError: any
  errorSourceValue: string
}

const DriverSource: React.FC<DriverSourceProps> = ({ form, requestError, errorSourceValue }) => {
  const { data: budgetDrivers } = useCtxDrivers()
  const functions = useAuthorizedData(useFunctions())

  const [textAreaRef, setTextAreaRef] = useState<TextAreaRef | null>(null)
  const cursor = useTextAreaCursor(textAreaRef)

  const getSourceFunctions = () => {
    const filteredFunctions = {}
    for (const func of Object.keys(functions)) {
      if (func === 'ref' || func === 'variable' || func === 'accumulate') {
        Object.assign(filteredFunctions, { [func]: functions[func] })
      }
    }
    return filteredFunctions
  }

  return (
    <div>
      <FormulaAddFunction
        form={form}
        cursor={cursor}
        translation={{
          formItem: 'financialStatementsPage:formula',
          select: 'financialStatementsPage:add-budget-driver'
        }}
        functions={budgetDrivers}
        requestError={requestError}
      />
      {requestError && <FormulaSuggestion error={requestError} />}
      {requestError && <FormulaError error={requestError} str={errorSourceValue} />}
      <FormulaSource
        cursor={cursor}
        form={form}
        functions={getSourceFunctions()}
        textAreaRef={textAreaRef}
        setTextAreaRef={setTextAreaRef}
      />
    </div>
  )
}

export default DriverSource
